import axiosInstance from './axiosInstance';

// Public category endpoints
export const getCategories = async () => {
  const response = await axiosInstance.get('/api/categories');
  return response.data;
};

export const getCategoryById = async (categoryId) => {
  const response = await axiosInstance.get(`/api/categories/${categoryId}`);
  return response.data;
};

export const getCategoryProducts = async (categoryId) => {
  const response = await axiosInstance.get(`/api/categories/${categoryId}/products`);
  return response.data;
};

// Admin category endpoints
export const getAdminCategories = async () => {
  const response = await axiosInstance.get('/api/admin/categories');
  return response.data;
};

export const createCategory = async (categoryName) => {
  const response = await axiosInstance.post('/api/admin/categories', {
    category: categoryName
  });
  return response.data;
};

export const updateCategory = async (categoryId, categoryName) => {
  const response = await axiosInstance.put(`/api/admin/categories/${categoryId}`, {
    category: categoryName
  });
  return response.data;
};

export const deleteCategory = async (categoryId) => {
  const response = await axiosInstance.delete(`/api/admin/categories/${categoryId}`);
  return response.data;
};

export const getCategoryProductsAdmin = async (categoryId) => {
  const response = await axiosInstance.get(`/api/admin/categories/${categoryId}/products`);
  return response.data;
};

const categoryService = {
  getCategories,
  getCategoryById,
  getCategoryProducts,
  getAdminCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  getCategoryProductsAdmin,
};

export default categoryService;
